import React from 'react';
import { Link } from 'react-router-dom';

const AuthInfo = ({ type }) => {

  if (type === "signup") {
    return (
      <div className="mt-4">
        <p>Sudah memiliki akun? Masuk <Link to="https://dashboard.biteship.com/signin">disini</Link></p>
        <p>Lupa password? Klik <Link to="/forgot_password/new">disini</Link></p>
      </div>
    )
  } else {
    return (
      <div className="mt-4">
        <p>Belum memiliki akun? Daftar <Link to="/signup">disini</Link></p>
        <p>Lupa password? Klik <Link to="/forgot_password/new">disini</Link></p>
      </div>
    )
  }

};


export default AuthInfo
